import React, { useEffect, useRef, useState } from "react";
import "../aseets/css/ExperienceSection.css";

const words = ["Success", "Growth", "Visibility", "Impact", "Results"];

const ExperienceSection = () => {
  /* =========================
     TYPING EFFECT STATE
  ========================= */
  const [typedWord, setTypedWord] = useState("");
  const wordIndex = useRef(0);
  const charIndex = useRef(0);
  const isDeleting = useRef(false);

  /* =========================
     TYPING EFFECT LOGIC
  ========================= */
  useEffect(() => {
    const typingInterval = setInterval(() => {
      const currentWord = words[wordIndex.current];

      if (!isDeleting.current) {
        setTypedWord(currentWord.slice(0, charIndex.current + 1));
        charIndex.current++;

        if (charIndex.current === currentWord.length) {
          setTimeout(() => (isDeleting.current = true), 900);
        }
      } else {
        setTypedWord(currentWord.slice(0, charIndex.current - 1));
        charIndex.current--;

        if (charIndex.current === 0) {
          isDeleting.current = false;
          wordIndex.current = (wordIndex.current + 1) % words.length;
        }
      }
    }, isDeleting.current ? 60 : 90);

    return () => clearInterval(typingInterval);
  }, []);

  /* =========================
     COUNT-UP ANIMATION
  ========================= */
  useEffect(() => {
    const section = document.querySelector(".gm-ex");
    const counters = document.querySelectorAll(".gm-ex-stat h3");

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            counters.forEach(counter => {
              const target = Number(counter.dataset.target);
              const duration = 1200;
              const start = performance.now();

              const update = (now) => {
                const progress = Math.min((now - start) / duration, 1);
                const value = Math.floor(progress * target);
                counter.textContent = value.toLocaleString();

                if (progress < 1) {
                  requestAnimationFrame(update);
                } else {
                  counter.textContent = target.toLocaleString() + "+";
                }
              };

              requestAnimationFrame(update);
            });
            obs.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="gm-ex">
      <div className="gm-ex-container">

        {/* LEFT CONTENT */}
        <div className="gm-ex-content">
          <span className="gm-ex-eyebrow">YOUR BRAND DESERVES MORE</span>

          <h2 className="gm-ex-title">
            <span className="gm-ex-typing">{typedWord}</span>
            <span className="gm-ex-dot">.</span>
            <span className="gm-ex-cursor">|</span>
          </h2>

          <p className="gm-ex-text">
            At <strong>Global Manch</strong>, we believe your brand deserves more
            than just visibility — it deserves meaningful growth. We blend
            creativity with technology to craft strategies that deliver real
            impact.
          </p>

          <p className="gm-ex-text">
            From building recognition to launching performance-driven campaigns,
            we ensure your brand thrives in today’s fast-changing digital world.
          </p>
        </div>

        {/* RIGHT STATS */}
        <div className="gm-ex-stats">

          <div className="gm-ex-stat">
            <h3 data-target="5">0</h3>
            <span>Years of Experience</span>
          </div>

          <div className="gm-ex-stat">
            <h3 data-target="1236">0</h3>
            <span>Successful Projects</span>
          </div>

          <div className="gm-ex-stat">
            <h3 data-target="436">0</h3>
            <span>Brands Transformed</span>
          </div>

          <div className="gm-ex-stat">
            <h3 data-target="780">0</h3>
            <span>Campaigns Launched</span>
          </div>

        </div>

      </div>
    </section>
  );
};

export default ExperienceSection;
